/**
 * Product permission catalog.
 * Legacy CE/OE strings remain for API dual-read during migration; prefer GlobalCapability + form grants.
 * @deprecated form-named string enums — use canForm() / canGlobal() when form_grants is available.
 */
export enum Permission {
  AccessEVIEWDashboard = 'Access CEWER dashboard',
  CreateReport = 'Create report',
  AccessIncidentRiskReports = 'Access incident/risk reports',
  ViewIncidentRiskReporterIdentity = 'View incident/risk reporter identity',
  ModifyReportInformation = 'Modify report information',
  ModifyPersonalIncidentRiskReports = 'Modify personal incident/risk reports',
  AccessAnalysisAndFiltersSection = 'Access analysis and filters section',
  AccessAndModifyParametersSettings = 'Access and modify parameters settings',
  ExportIncidentList = 'Export incident list',
  RequestIncidentRiskReports = 'Request modifications of risk/incident logged by others',
  AccessManagement = 'Access Management',
  UserManagement = 'User Management',
  /** @deprecated use form grant view on form 1 */
  ViewReportsMapConflictividadElectoral = 'View Reports - Map - Conflictividad Electoral',
  /** @deprecated use form grant view on form 2 */
  ViewReportsMapElectionOperations = 'View Reports - Map - Operaciones Electorales',
  /** @deprecated */
  ViewReportsListConflictividadElectoral = 'View Reports - List - Conflictividad Electoral',
  /** @deprecated */
  ViewReportsListElectionOperations = 'View Reports - List - Operaciones Electorales',
  /** @deprecated */
  CommentReportConflictividadElectoral = 'Comment Report - Conflictividad Electoral',
  /** @deprecated */
  CommentReportOperacionesElectorales = 'Comment Report - Operaciones Electorales',
  /** @deprecated */
  CreateANewreportConflictividadElectoral = 'Create a new report - Conflictividad Electoral',
  /** @deprecated */
  CreateANewReportOperacionesElectorales = 'Create a new report - Operaciones Electorales',
  /** @deprecated */
  EditOwnIncidentReportContentConflictividadElectoral = 'Edit own incident report content - Conflictividad Electoral',
  /** @deprecated */
  EditOwnIncidentReportContentOperacionesElectorales = 'Edit own incident report content - Operaciones Electorales',
  /** @deprecated */
  EditAndManageReportsConflictividadElectoral = 'Edit and manage reports - Conflictividad Electoral',
  /** @deprecated */
  EditAndManageReportsOperacionesElectorales = 'Edit and manage reports - Operaciones Electorales',
  AccessAndEditIncidentReportsFormNamesOfDeports = 'Access and edit incident reports form - Names of reports',
  AccessAndEditIncidentIndicators = 'Access and edit incident indicators',
  /** @deprecated */
  DeleteReportsConflictividadElectoral = 'Delete reports - Conflictividad Electoral',
  /** @deprecated */
  DeleteReportsOperacionesElectorales = 'Delete reports - Operaciones Electorales',
  /** @deprecated */
  ViewIncidentReporterIdentityConflictividadElectoral = 'View incident reporter identity - Conflictividad Electoral',
  /** @deprecated */
  ViewIncidentReporterIdentityOperacionesElectorales = 'View incident reporter identity - Operaciones Electorales',
  /** @deprecated */
  ExportIncidentListConflictividadElectoral = 'Export incident list - Conflictividad Electoral',
  /** @deprecated */
  ExportIncidentListOperacionesElectorales = 'Export incident list - Operaciones Electorales',
  /** @deprecated */
  AccessAnalysisDashboardConflictividadElectoral = 'Access Analysis Dashboard - Conflictividad Electoral',
  /** @deprecated */
  AccessAnalysisDashboardOperacionesElectorales = 'Access Analysis Dashboard - Operaciones Electorales',
  // Global capability codes (seeded)
  UsersManage = 'users.manage',
  UsersResetMfa = 'users.reset_mfa',
  RolesManage = 'roles.manage',
  TagsManage = 'tags.manage',
  FormsConfigure = 'forms.configure',
  SettingsManage = 'settings.manage'
}
